import { Icon, WithNAFallback } from '@design';
import React from 'react';

import styles from './LinkCell.module.scss';

export const LinkCell = ({ url }: { url?: string }) => {
  return (
    <WithNAFallback
      check={!!url}
      value={
        <Icon
          className={styles.icon}
          data-testid="link-cell"
          iconName="HtmlLinkIcon"
          size={20}
          onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
        />
      }
    />
  );
};
